export default class Rotas {
    static ETAPAS = {
        chave: 'etapas',
        nome: 'Etapas'
    }
    static RESUMO = {
        chave: 'resumo',
        nome: 'Resumo'
    }
    static MODULOS = {
        chave: 'modulos',
        nome: 'Modulos'
    }
    static ASSINATURA = {
        chave: 'assinatura',
        nome: 'DetalheAssinatura'
    }
    static DETALHE_AVARIA = {
        chave: 'detalhe-avaria',
        nome: 'DetalheAvaria'
    }
    static DETALHE_FOTO = {
        chave: 'edicao-imagem',
        nome: 'DetalheFoto'
    }
    static NOT_FOUND = {
        chave: 'not-found',
        nome: 'NotFound'
    }
    static TIRAR_FOTO = {
        chave: 'tirar-foto',
        nome: 'TirarFoto'
    }
}